import { Col, Row, Typography } from "antd";
import React from "react";
import { refineTimer } from "util/refine_timer.function";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CardBailiffPreview = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const speaker = data?.speaker;
  const from = data?.from;
  const to = data?.to;
  const text = data?.fix || data?.text;
  const labelFrom = refineTimer({ timer: from });
  const labelTo = refineTimer({ timer: to });
  const label = `${labelFrom} - ${labelTo}`;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Typography.Title style={{ margin: 0 }} level={5}>
          Speaker: {speaker}
        </Typography.Title>
        <div style={{ fontStyle: "italic", color: "gray" }}>{label}</div>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Typography.Paragraph>{text}</Typography.Paragraph>
      </Col>
    </Row>
  );
};
export default CardBailiffPreview;
